<template>
    <div class="SubWebPage" v-loading.fullscreen.lock="fullscreenLoading">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
            <!-- 基础信息 -->
            <el-card class="box-card">
                <div slot="header" class="card-header">
                    <h3 class="card-title titleCont">
                        <span class="spIcon"></span>
                        {{Title}}
                    </h3>
                </div>
                <div class="card-body pb-5">
                    <el-form-item label="专业名称" prop="name">
                        <el-input v-model="ruleForm.name" placeholder="请输入专业名称"></el-input>
                    </el-form-item>
                    <el-form-item label="招生专业代码" prop="code">
                        <el-input v-model="ruleForm.code" placeholder="请输入招生专业代码"></el-input>
                    </el-form-item>
                    <el-form-item label="批次" prop="batchId">
                        <el-select v-model="ruleForm.batchId" disabled filterable clearable placeholder="请选择批次" style="width:100%;">
                            <el-option v-for="item in optBatch" :key="item.batchId" :label="item.name" :value="item.batchId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="办学层次" prop="bxcc">
                        <el-select v-model="ruleForm.bxcc" filterable placeholder="请选择办学层次" style="width:100%;">
                            <el-option v-for="item in optBxcc" :key="item.Value" :label="item.Text" :value="item.Value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="培养目标" prop="pymm">
                        <el-select v-model="ruleForm.pymm" filterable placeholder="请选择培养目标" style="width:100%;">
                            <el-option v-for="item in optPymm" :key="item.Value" :label="item.Text" :value="item.Value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="学制" prop="xz">
                        <el-input v-model="ruleForm.xz" placeholder="请输入学制"></el-input>
                    </el-form-item>
                    <el-form-item label="计划数" prop="planCount">
                        <el-input v-model="ruleForm.planCount" placeholder="请输入计划数"></el-input>
                    </el-form-item>
                    <el-form-item label="学费" prop="tuitionFee">
                        <el-input v-model="ruleForm.tuitionFee" placeholder="请输入学费"></el-input>
                    </el-form-item>
                    <el-form-item label="代办费" prop="agencyFee">
                        <el-input v-model="ruleForm.agencyFee" placeholder="请输入代办费"></el-input>
                    </el-form-item>
                    <el-form-item label="住宿费" prop="accommodationFee">
                        <el-input v-model="ruleForm.accommodationFee" placeholder="请输入住宿费"></el-input>
                    </el-form-item>
                    <el-form-item label="保险费" prop="insuranceFee">
                        <el-input v-model="ruleForm.insuranceFee" placeholder="请输入保险费"></el-input>
                    </el-form-item>
                    <el-form-item label="优先级">
                        <el-input v-model="ruleForm.priority" placeholder="请输入优先级"></el-input>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input v-model="ruleForm.remark" type="textarea" :rows="2" placeholder="请输入备注">
                        </el-input>
                    </el-form-item>
                </div>
            </el-card>
        </el-form>
        <div class="pt-10">
            <el-button icon="el-icon-back" @click="onBack()">返回</el-button>
            <el-button icon="el-icon-refresh" @click="onReset()">重 置</el-button>
            <el-button type="primary" icon="el-icon-circle-check" @click="onSubmit()">提交</el-button>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            fullscreenLoading: false,
            Title: "新增专业",
            // 数据
            ruleForm: {
                code: null,
                name: null,
                batchId: null,
                bxcc: null,
                pymm: null,
                xz: null,
                planCount: null,
                tuitionFee: null,
                agencyFee: null,
                accommodationFee: null,
                insuranceFee: null,
                priority: null,
                remark: null,
            },
            ruleFormReset: null,
            rules: {
                name: [
                    { required: true, message: '请输入专业名称', trigger: 'blur' },
                ],
                batchId: [
                    { required: true, message: '请选择批次', trigger: 'blur' },
                ],
                bxcc: [
                    { required: true, message: '请选择办学层次', trigger: 'blur' },
                ],
                pymm: [
                    { required: true, message: '请选择培养目标', trigger: 'blur' },
                ],
                planCount: [
                    { required: true, message: '请输入计划数', trigger: 'blur' },
                ],
                tuitionFee: [
                    { required: true, message: '请输入学费', trigger: 'blur' },
                ],
                agencyFee: [
                    { required: true, message: '请输入代办费', trigger: 'blur' },
                ],
                accommodationFee: [
                    { required: true, message: '请输入住宿费', trigger: 'blur' },
                ],
                insuranceFee: [
                    { required: true, message: '请输入保险费', trigger: 'blur' },
                ],
            },
            optBatch: [],
            optBxcc: [],
            optPymm: [],
        }
    },
    created() {
        let that = this;
        let id = that.$route.params.id;
        let batchId = that.$route.query.BatchId;
        ajaxGet(that, "/api/admin/enrollmajor/bxcc", null, function(resBxcc) {
            if (resBxcc && resBxcc.length > 0) {
                resBxcc.forEach(element => {
                   element.Value = Number(element.Value); 
                });
                that.optBxcc = resBxcc;
            }
        })
        ajaxGet(that, "/api/admin/enrollmajor/pymm", null, function(resPymm) {
            if (resPymm && resPymm.length > 0) {
                resPymm.forEach(element => {
                   element.Value = Number(element.Value); 
                });
                that.optPymm = resPymm;
            }
        })
        if (id) {
            that.Title = "编辑专业";
            that.ruleForm.majorId = id;
            that.fullscreenLoading = true;
            ajaxGet(that, '/api/admin/enrollbatch', null, function (resBatch) {
                ajaxGet(that, "/api/admin/enrollmajor/" + id, null, function (res) {
                    that.optBatch = resBatch;

                    that.ruleForm = res;
                    that.ruleFormReset = JSON.parse(JSON.stringify(that.ruleForm));

                    that.fullscreenLoading = false;
                })
            })
            

        } else {
            that.Title = "新增专业";
            that.ruleForm.majorId = null;
            that.ruleForm.batchId = batchId;
            that.ruleFormReset = JSON.parse(JSON.stringify(that.ruleForm));
            that.fullscreenLoading = true;
            ajaxGet(that, '/api/admin/enrollbatch', null, function (resBatch) {
                that.fullscreenLoading = false;
                that.optBatch = resBatch;
            })
            
        }

    },
    methods: {
        onBack() {
            back(this);
        },
        onReset() {
            let that = this;
            that.ruleForm = JSON.parse(JSON.stringify(that.ruleFormReset));
            that.$refs.ruleForm.clearValidate();
        },
        onSubmit() {
            let that = this;
            that.$refs["ruleForm"].validate(valid => {
                if (valid) {
                    that.fullscreenLoading = true;
                    that.ruleForm.priority = that.ruleForm.priority ? that.ruleForm.priority : 0;
                    if (that.ruleForm.majorId) { //编辑
                        ajaxPut(that, "/api/admin/enrollmajor/" + that.ruleForm.majorId, that.ruleForm, function () {
                            that.fullscreenLoading = false;
                            that.onBack();
                        })
                    } else { //新增
                        ajaxPost(that, "/api/admin/enrollmajor", that.ruleForm, function () {
                            that.fullscreenLoading = false;
                            that.onBack();
                        })
                    }

                } else {
                    setTimeout(() => {
                        var isError = document.getElementsByClassName("is-error");
                        var el = isError[0].querySelector('input') || isError[0].
                            querySelector('textarea');
                        if (el) {
                            el.focus();
                        }
                    }, 100)
                    return false;
                }
            })

        },
    }
}
</script>

<style lang="less" scoped>

</style>